<template>
  <div class="col-2 col-xl-2 col-lg-3 col-md-4 offset-xl-4 offset-lg-5 fixed">
    <div class="list-group">
      <a
        href="#"
        class="list-group-item list-group-item-action bg-light"
        aria-current="true"
      >
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">Taha Malaldır</h5>
          <small>3 days ago</small>
        </div>
        <p class="mb-1">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste fuga ex
          quibusdam saepe! Mollitia impedit earum tenetur sunt animi eveniet?.
        </p>
      </a>
      <a href="#" class="list-group-item list-group-item-action bg-light">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">Taha Malaldır</h5>
          <small class="text-muted">3 days ago</small>
        </div>
        <p class="mb-1">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste fuga ex
          quibusdam saepe! Mollitia impedit earum tenetur sunt animi eveniet?.
        </p>
      </a>
      <a href="#" class="list-group-item list-group-item-action bg-light">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">Taha Malaldır</h5>
          <small class="text-muted">3 days ago</small>
        </div>
        <p class="mb-1">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste fuga ex
          quibusdam saepe! Mollitia impedit earum tenetur sunt animi eveniet?.
        </p>
      </a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.fixed {
  position: fixed;
}
@media (max-width: 768px) {
  .fixed {
    position: relative;
  }
}
@media (max-width: 767px) {
  .fixed {
    display: none;
  }
}
</style>
